import React from "react";
import { Dropdown, Menu, Tooltip } from "antd";
import { QuestionOutlined, FileTextOutlined } from "@ant-design/icons";
import ButtonItem from "./ButtonItem";
import { MANUALES_POR_MODULO, abrirManual } from "./manualesAyuda";


const BotonAyudaManuales = ({ modulo, size }) => {
  const manuales = MANUALES_POR_MODULO[modulo] || [];
  if (manuales.length === 0) return null;

  if (manuales.length === 1) {
    return (
      <Tooltip title="Ver manual" placement="bottomRight">
        <ButtonItem blanco botonAncho size={size} icon={<QuestionOutlined />} onClick={() => abrirManual(manuales[0])} />
      </Tooltip>
    );
  }

  const menu = (
    <Menu onClick={({ key }) => abrirManual(manuales.find((m) => m.key === key))}>
      {manuales.map((m) => (
        <Menu.Item key={m.key} icon={<FileTextOutlined />}>
          {m.titulo}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      <span style={{ display: "inline-block" }}>
        <Tooltip title="Manuales" placement="bottomRight">
          <ButtonItem blanco botonAncho size={size} icon={<QuestionOutlined />} />
        </Tooltip>
      </span>
    </Dropdown>
  );
};

export default BotonAyudaManuales;
